import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Button,
} from '@mui/material';
import { ExitToApp as LogoutIcon } from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import DashboardOverview from './DashboardOverview';

const Dashboard = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout Error:', error);
    }
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Button
        variant="outlined"
        color="inherit"
        onClick={handleLogout}
        startIcon={<LogoutIcon />}
        sx={{
          position: 'absolute',
          top: 16,
          right: 16,
          zIndex: 1,
        }}
      >
        Logout
      </Button>
      
      <Box>
        <DashboardOverview />
      </Box>
    </Container>
  );
};

export default Dashboard; 